export default "__VITE_ASSET__B0_83Sz9__"